import { render } from "./HomeContent1.vue?vue&type=template&id=31aed615&scoped=true"
const script = {}

import "./HomeContent1.vue?vue&type=style&index=0&id=31aed615&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31aed615"]])

export default __exports__